export default function CSMModule() {
  return (
    <section className="padded-box">
      <p className="eyebrow">Climate Expertise</p>
      <h3>
        Receive hands-on support every step of the way, without the need for
        consultants
      </h3>
      <p className="intro">
        Work directly with our in-house climate leads, who bring expertise from
        McKinsey, Stanford, Apple, and other prestigious climate programs.
      </p>
      <style jsx>{`
        section {
          align-self: center;
        }
        p.eyebrow {
          color: #4f9a90;
          font-weight: bold;
        }
        p.intro {
          color: #263245;
          font-size: 21px;
          line-height: 32px;
        }
      `}</style>
    </section>
  );
}
